import { VetWorkoutsTab } from "interfaces/VetWorkoutsTab";
import { ERowColumn } from "components/VetExamsTable/types";

export const createConfigTable = (activeTab: VetWorkoutsTab): ERowColumn[] => {
  switch (activeTab.value) {
    case "exams":
      return [
        ERowColumn.HORSE_AND_TRAINER,
        ERowColumn.HISTORY,
        ERowColumn.WORK_DATE,
        ERowColumn.REQUESTED,
        ERowColumn.RISK_LEVEL,
        ERowColumn.FLAG_REQUEST,
        ERowColumn.BARN,
        ERowColumn.STALL,
        ERowColumn.EXAM_STATUS,
        ERowColumn.CSA,
        ERowColumn.HSF,
        ERowColumn.DLW,
        ERowColumn.DLR,
        ERowColumn.LAST_EXAM,
        ERowColumn.ASSIGNED_VET,
        ERowColumn.UNASSIGN,
        ERowColumn.EXAM,
        ERowColumn.ACTIVE_VET_LISTS,
        ERowColumn.RISK_FACTOR_SCORE,
        ERowColumn.RISK_FACTORS,
        ERowColumn.EXTENDER
      ];
    case "passed":
      return [
        ERowColumn.HORSE_AND_TRAINER,
        ERowColumn.WORK_DATE,
        ERowColumn.REQUESTED,
        ERowColumn.RISK_LEVEL,
        ERowColumn.BARN,
        ERowColumn.STALL,
        ERowColumn.EXAM_TYPE,
        ERowColumn.ASSIGNED_VET,
        ERowColumn.CSA,
        ERowColumn.HSF,
        ERowColumn.DLW,
        ERowColumn.DLR,
        ERowColumn.LAST_EXAM
      ];
    case "failed":
      return [
        ERowColumn.HORSE_AND_TRAINER,
        ERowColumn.WORK_DATE,
        ERowColumn.REQUESTED,
        ERowColumn.RISK_LEVEL,
        ERowColumn.BARN,
        ERowColumn.STALL,
        ERowColumn.ASSIGNED_VET,
        ERowColumn.CSA,
        ERowColumn.HSF,
        ERowColumn.DLW,
        ERowColumn.DLR,
        ERowColumn.LAST_EXAM
      ];
    case "rejected":
      return [
        ERowColumn.HORSE_AND_TRAINER,
        ERowColumn.WORK_DATE,
        ERowColumn.REQUESTED,
        ERowColumn.RISK_LEVEL,
        ERowColumn.BARN,
        ERowColumn.STALL,
        ERowColumn.CSA,
        ERowColumn.HSF,
        ERowColumn.DLW,
        ERowColumn.DLR,
        ERowColumn.LAST_EXAM,
        ERowColumn.IMAGE_DIAGNOSTICS_REQUIRED
      ];
    // Request tab
    default:
      return [
        ERowColumn.HORSE_AND_TRAINER,
        ERowColumn.HISTORY,
        ERowColumn.WORK_DATE,
        ERowColumn.REQUESTED,
        ERowColumn.RISK_LEVEL,
        ERowColumn.BARN,
        ERowColumn.STALL,
        ERowColumn.CSA,
        ERowColumn.HSF,
        ERowColumn.DLW,
        ERowColumn.DLR,
        ERowColumn.LAST_EXAM,
        ERowColumn.FLAG_REQUEST,
        ERowColumn.ACTIVE_VET_LISTS,
        ERowColumn.RISK_FACTOR_SCORE,
        ERowColumn.RISK_FACTORS,
        ERowColumn.EXTENDER
      ];
  }
};
